import { render } from "./DumpsterSelection.vue?vue&type=template&id=71fcff1a"
import script from "./DumpsterSelection.vue?vue&type=script&lang=js"
export * from "./DumpsterSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__